import apiClient from './apiClient';

// ============================================================
// Types
// ============================================================

export interface QueryRequest {
  year: number;   // 薪資年度
  month: number;  // 薪資月份 (1-12)
}

export interface DisbursementRow {
  empCode: string;
  empName: string;
  deptCode: string;
  bankName: string;
  bankAcct: string;
  netPay: number;
  grossPay: number;
  deduction: number;
  printPay: number;
}

export interface QueryResponse {
  rows: DisbursementRow[];
  totalCount: number;
  totalPay: number;
  yearMonth: string;
}

export interface ExportRequest {
  year: number;
  month: number;
  transferDate: string; // YYYY-MM-DD
}

export interface ExportRow {
  empName: string;
  bankName: string;
  bankAcct: string;
  amount: string;
}

export interface ExportResponse {
  filename: string;
  content: string;
  rows: ExportRow[];
  totalAmt: number;
}

export interface DefaultYearMonth {
  year: number;
  month: number;
}

export interface LookupResult {
  code: string;
  name: string;
}

// ============================================================
// API Client
// ============================================================

export const pw933bApi = {
  async query(req: QueryRequest): Promise<QueryResponse> {
    const res = await apiClient.post('/api/pw933b/query', req);
    return res.data;
  },

  async exportFile(req: ExportRequest): Promise<ExportResponse> {
    const res = await apiClient.post('/api/pw933b/export', req);
    return res.data;
  },

  async getDefaults(): Promise<DefaultYearMonth> {
    const res = await apiClient.get('/api/pw933b/defaults');
    return res.data;
  },

  async lookup(type: string, code: string): Promise<LookupResult> {
    const res = await apiClient.get(`/api/pw933b/lookup/${type}/${encodeURIComponent(code)}`);
    return res.data;
  },
};
